module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/abf1ce5b92e4d0f6016a0215aa880ab3.png";